"use client";
import { Button } from "@mui/material";
import { Home } from "lucide-react";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import UserMenu from "./user-information/UserMenu";

export default function TopBar() {
  const router = useRouter();
  const pathname = usePathname();

  return (
    <div className="static top-0 flex h-16 w-full items-center justify-between bg-bma-dark-blue">
      <Button
        id="Home"
        onClick={() => {
          if (pathname === "/") {
            window.dispatchEvent(new Event("resetTabs"));
          } else {
            router.push("/");
          }
        }}
      >
        <Home color="white" />
      </Button>
      <Image
        src="/BMALogo.svg"
        alt="BMA Logo"
        height={30}
        width={103}
        priority
      />
      <UserMenu />
    </div>
  );
}
